import { useEffect } from "react";
import { IHook } from "./homeNps.types";

export const useHomeNps: IHook = ({ showModal }) => {
  useEffect(() => {
    if (!showModal) {
      return;
    }

    showModal();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
